var render, staticRenderFns
import script from "./SopBlockDetailMixin.vue?vue&type=script&lang=ts&"
export * from "./SopBlockDetailMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4ad0b6",
  null
  
)

export default component.exports